import firebase from '@/config/firebase'
import globals from '@/config/globals'
import { firestoreAction } from 'vuexfire'

const getDefaultState = () => ({
  collection: null,
  status: {
    value: false,
    data: null
  }
})

const dentist = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setCollection(state, data) {
      state.collection = data
    },

    setStatus(state, data) {
      state.status = data
    },

    reset(state) {
      Object.assign(state, getDefaultState())
      state.status = { value: false, data: 'Data wiped.' }
    }
  },

  actions: {
    loadCollection: firestoreAction(({
      bindFirestoreRef, commit, rootState, rootGetters
    }) => {
      let query = false
      let response = null

      if (rootGetters['account/type'] === 'dentist') {
        if (rootState.account.profile.dentist) {
          query = firebase.firestore().collection(globals.firebase.collection.dentists).doc(rootState.account.profile.dentist)
        } else {
          commit('setStatus', { value: false, data: 'Missing Dentist Identifier.' })
          console.error('Dentist Load - Error loading dentist ID')
        }
      } else {
        query = firebase.firestore().collection(globals.firebase.collection.dentists)
      }

      if (query) {
        response = bindFirestoreRef('collection', query)
          .then(() => {
            commit('setStatus', { value: true, data: 'Collection bound.' })
            console.info('Dentists collection bound.')
          })
          .catch((error) => {
            commit('setStatus', { value: false, data: error.stack.toString() })
            console.error('Error binding collection (dentists):', error)
          })
      }

      return response
    }),

    updateAvailability: firestoreAction(({ rootState }, availability) => firebase.firestore().collection(globals.firebase.collection.dentists).doc(rootState.account.profile.dentist).update({ availability })),

    reset: firestoreAction(({ commit, unbindFirestoreRef }) => {
      commit('reset')
      unbindFirestoreRef('collection')
    })
  },

  getters: {
    find: (state, getters, rootState, rootGetters) => (id) => {
      let result = null

      if (rootGetters['account/type'] === 'dentist') {
        result = state.collection
      } else {
        result = state.collection.find((d) => d.id === id)
      }

      return result
    },

    availability: (state, getters, rootState, rootGetters) => (id = null) => {
      let result = null

      if (rootGetters['account/type'] === 'dentist') {
        result = state.collection.availability
      } else if (id && state.collection[id]) {
        result = state.collection[id].availability
      }

      return result
    }
  }
}

export default dentist
